import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { PATH_USER } from "../constants/urlPaths";
import {
  GetUserMetadataRequest,
  GetUserMetadataResponse,
  UpdateUserCreditCampaignFtuxMetadataRequest,
  UpdateUserCreditCampaignFtuxMetadataResponse,
  UpdateUserMetadataRequest,
  UpdateUserMetadataResponse,
} from "redmond";
import { getIframeAuthHeaders } from "../utils/sessionTokenUtil";

export const userApi = createApi({
  reducerPath: "user",
  baseQuery: fetchBaseQuery({
    baseUrl: PATH_USER,
    prepareHeaders: (headers) => {
      Object.entries(getIframeAuthHeaders()).forEach(([key, value]) =>
        headers.set(key, value)
      );
      return headers;
    },
  }),
  tagTypes: [],
  endpoints: (build) => ({
    getUserMetadata: build.query<
      GetUserMetadataResponse,
      GetUserMetadataRequest
    >({
      query(req) {
        return {
          url: "preference/metadata",
          method: "POST",
          body: req,
        };
      },
    }),
    updateUserMetadata: build.mutation<
      UpdateUserMetadataResponse,
      UpdateUserMetadataRequest
    >({
      query(req) {
        return {
          url: "preference/metadata",
          method: "PUT",
          body: req,
        };
      },
    }),

    updateUserCreditCampaignFtuxMetadata: build.mutation<
      UpdateUserCreditCampaignFtuxMetadataResponse,
      UpdateUserCreditCampaignFtuxMetadataRequest
    >({
      query(req) {
        return {
          url: "preference/metadata/creditCampaignFtux",
          method: "POST",
          body: req,
        };
      },
    }),
  }),
});

export const {
  useGetUserMetadataQuery,
  useUpdateUserMetadataMutation,
  useUpdateUserCreditCampaignFtuxMetadataMutation,
} = userApi;
